"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const noop_1 = __importDefault(require("lodash-es/noop"));
const useToggle_1 = __importDefault(require("./useToggle"));
const isEmpty = (value) => value == null || String(value).trim() === '';
const usePlaceholder = (value, { onInput = noop_1.default, onChange = noop_1.default }) => {
    const [isValueEmpty, _, setValueEmptiness] = (0, useToggle_1.default)(isEmpty(value));
    (0, react_1.useEffect)(() => {
        setValueEmptiness(isEmpty(value));
    }, [setValueEmptiness, value]);
    const handleInput = (0, react_1.useCallback)((e) => {
        const { target } = e;
        // check value with delay because of possible inner value transformations
        setTimeout(() => setValueEmptiness(isEmpty(target.value)), 0);
        if (onInput) {
            onInput(e);
        }
    }, [onInput, setValueEmptiness]);
    const handleChange = (0, react_1.useCallback)((value, event) => {
        if (onChange) {
            onChange(value, event);
        }
        setValueEmptiness(isEmpty(value));
    }, [onChange, setValueEmptiness]);
    return { isValueEmpty, handleInput, handleChange };
};
exports.default = usePlaceholder;
